import React, { Component, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import style from "./styles";
import AboutHeader from "./AboutHeader/AboutHeader";
import AllSectionWrapper from "./AllSectionWrapper/AllSectionWrapper";
import MonetizationAllSectionWrapper from "./AllSectionWrapper/MonetizationAllSectionWrapper";
import Loader from "../shared/molecules/Loader/Loader";
import adp_data_en from "../../static/staticData/locales/en/agent_ldp.en.json";
import adp_data_es from "../../static/staticData/locales/es/agent_ldp.es.json";
import { getAdpProperties } from "static/staticData/omniture/adp";
import { PAGE_TRACKING, LANGUAGE } from "static/staticData/omniture/trackingConstants";
import {
  trackOmniturePageLoad,
  trackOmnitureModuleImpression,
} from "static/staticData/omniture/omnitureUtils";
import { useUserState, userStateSelectors } from "@rdc-npm/rdc-app-context";
import dynamic from "next/dynamic";
import sbjs from "sourcebuster";
const AboutHeaderSSRfalse = dynamic(() => import("./AboutHeader/AboutHeader"), {
  ssr: false,
});

const AllSectionWrapperContainer = (props) => {
  const isUserLoggedIn = useUserState(userStateSelectors.isLoggedInSelector);
  const { data: loginData = {} } = useUserState(userStateSelectors.profileSelector);
  const nar_only =
    props.agentdetail && props.agentdetail.agent_bio && props.agentdetail.agent_bio.nar_only;
  const timerID = useRef();

  useEffect(() => {
    if (timerID.current) clearTimeout(timerID.current);
    timerID.current = setTimeout(() => {
      const properties = getAdpProperties(
        props && props.agentdetail && props.agentdetail.agent_bio,
        PAGE_TRACKING.ADP_PAGE.PAGE_TYPE,
        LANGUAGE.ENGLISH,
      );
      //if (nar_only === 0) {
      if (nar_only === 0 && props.userFlow !== "typein" && props.isSearchEngineUsed) {
        trackOmniturePageLoad(PAGE_TRACKING.ADP_PAGE.PAGE_NAME_NON_NAR, properties);
        if (props.agentdetail?.lex_agent_list?.length > 0) {
          properties.dynamicElements = PAGE_TRACKING.ADP_PAGE.PAGE_MODULE_WITH_AGENT;
          if (!properties.dynamicModules)
            properties.dynamicModules = PAGE_TRACKING.ADP_PAGE.PAGE_MODULE_WITH_AGENT;
        } else {
          properties.dynamicElements = PAGE_TRACKING.ADP_PAGE.PAGE_MODULE_NO_AGENT;
          if (!properties.dynamicModules)
            properties.dynamicModules = PAGE_TRACKING.ADP_PAGE.PAGE_MODULE_NO_AGENT;
        }
        trackOmnitureModuleImpression(properties);
      } else {
        trackOmniturePageLoad(PAGE_TRACKING.ADP_PAGE.PAGE_NAME_NAR, properties);
      }
    }, 5000);
  });

  //if (nar_only === 0) {
  if (nar_only === 0 && props.userFlow !== "typein" && props.isSearchEngineUsed) {
    return (
      <MonetizationAllSectionWrapper
        {...props}
        isUserLoggedIn={isUserLoggedIn}
        loginData={loginData}></MonetizationAllSectionWrapper>
    );
  } else {
    return (
      <AllSectionWrapper
        {...props}
        isUserLoggedIn={isUserLoggedIn}
        loginData={loginData}></AllSectionWrapper>
    );
  }
};

AllSectionWrapperContainer.propTypes = {
  isUserLoggedIn: PropTypes.bool,
  loginData: PropTypes.object,
  agentdetail: PropTypes.object,
  userFlow: PropTypes.string,
  isSearchEngineUsed: PropTypes.bool,
};

export default class AgentDetailPage extends Component {
  state = {
    showMasonModal: false,
    userFlow: "",
    isSearchEngineUsed: false,
  };
  componentDidMount() {
    sbjs.init();
    this.setState({ userFlow: sbjs.get.current.typ });
    const previousUrl = document.referrer;
    if (previousUrl?.includes("google.com") || previousUrl?.includes("bing.com")) {
      this.setState({ isSearchEngineUsed: true });
    }
    const { agentdetail } = this.props;
    const { advertiser_id, nrds_id } = agentdetail?.agent_bio;
    if (advertiser_id && nrds_id) {
      // profile(advertiser_id, nrds_id);
      // socialUpdates(advertiser_id, nrds_id);
    }
    window.scrollTo(0, 0);

    const sessionStorage_transfer = function(event) {
      if (!event) {
        event = window.event;
      }
      if (!event.newValue) return;
      if (event.key == "getSessionStorage") {
        localStorage.setItem("sessionStorage", JSON.stringify(sessionStorage));
        localStorage.removeItem("sessionStorage");
      } else if (event.key == "sessionStorage" && !sessionStorage.length) {
        var data = JSON.parse(event.newValue);
        for (var key in data) {
          sessionStorage.setItem(key, data[key]);
        }
      }
    };
    if (window.addEventListener) {
      window.addEventListener("storage", sessionStorage_transfer, false);
    } else {
      window.attachEvent("onstorage", sessionStorage_transfer);
    }
    if (!sessionStorage.length) {
      localStorage.setItem("getSessionStorage", "foobar");
      localStorage.removeItem("getSessionStorage", "foobar");
    }
  }
  componentDidUpdate(prevProps) {
    const { socialUpdateData, fetchCheckins, agentdetail } = this.props;
    if (prevProps.socialUpdateData != socialUpdateData) {
      const { advertiser_id, nrds_id } = agentdetail?.agent_bio;
      socialUpdateData && socialUpdateData.length > 0
        ? fetchCheckins(advertiser_id, nrds_id)
        : null;
    }
  }
  socialUpdates = () => {
    const { socialUpdates, profileData } = this.props;
    if (socialUpdates && profileData && profileData.social_connections) {
      const social_connections = socialUpdates && profileData && profileData.social_connections;
      social_connections.fulfillment_id = profileData.fulfillment_id;
      socialUpdates(social_connections);
    }
  };
  showShareModal = (agentdetail) => {
    if (this.props.showShareModal) {
      this.props.showShareModal(agentdetail);
    }
  };
  showRecommendationModal = (m) => {
    if (this.props.showRecommendationModal) {
      this.props.showRecommendationModal(m);
    }
  };
  ask_a_question_modal = (m) => {
    if (this.props.ask_a_question_modal) {
      this.props.ask_a_question_modal(m);
    }
  };

  showReviewModal = (agentdetail) => {
    if (this.props.showReviewModal) {
      this.props.showReviewModal(agentdetail);
    }
  };

  getStarted = () => {
    this.setState({ showMasonModal: true });
  };
  render() {
    let {
      query,
      agentdetail,
      feedbackData,
      recommendationData,
      hestiaData,
      hestiaInformation,
      socialUpdateData,
      fetchCheckinsData,
      profileData,
      showReviewModal,
      clickDetectorAndScroll,
      clickDetectorData,
      isBotAndDeviceType,
      socialloading,
    } = this.props;

    const langCode = query && query.langCode;
    let lang;
    if (langCode === "es") {
      lang = adp_data_es[langCode];
    } else {
      lang = adp_data_en[langCode];
    }

    if (agentdetail) {
      agentdetail.lang = lang;
    }

    const { description } = this.props?.agentdetail?.agent_bio || {};

    const deviceType = isBotAndDeviceType && isBotAndDeviceType.deviceType;
    return (
      <div className="agentPageWrapper" data-testid="component-agentDetailPage" id="far_page">
        {this.props && this.props.farprofileloading ? <Loader></Loader> : ""}

        <style jsx>{style}</style>

        <div className="aboutHeaderMainWrapper">
          {description ? (
            <AboutHeaderSSRfalse
              deviceType={deviceType}
              query={query}
              agentdetail={agentdetail}
              reviewData={feedbackData}
              recommendationData={recommendationData}
              showShareModal={() => this.showShareModal(agentdetail)}
              lang={lang}
              clickDetectorAndScroll={clickDetectorAndScroll}
            />
          ) : (
            <AboutHeader
              deviceType={deviceType}
              query={query}
              agentdetail={agentdetail}
              reviewData={feedbackData}
              recommendationData={recommendationData}
              showShareModal={() => this.showShareModal(agentdetail)}
              lang={lang}
              clickDetectorAndScroll={clickDetectorAndScroll}
            />
          )}
        </div>
        <AllSectionWrapperContainer
          socialUpdatesOnClick={this.socialUpdates}
          socialloading={socialloading}
          agentdetail={agentdetail}
          profileData={profileData}
          reviewData={feedbackData}
          recommendationData={recommendationData}
          socialUpdateData={socialUpdateData}
          fetchCheckinsData={fetchCheckinsData}
          hestiaData={hestiaData}
          hestiaInformation={hestiaInformation}
          showShareModal={() => this.showShareModal(agentdetail)}
          showRecommendationModal={() => this.showRecommendationModal(this.props)}
          ask_a_question_modal={() => this.ask_a_question_modal(this.props)}
          showReviewModal={() => showReviewModal(agentdetail)}
          {...this.props}
          lang={lang}
          langCode={langCode}
          clickDetectorAndScroll={clickDetectorAndScroll}
          clickDetectorData={clickDetectorData}
          isSearchEngineUsed={this.state.isSearchEngineUsed}
          userFlow={this.state.userFlow}
        />
      </div>
    );
  }
}

AgentDetailPage.defaultProps = {};

AgentDetailPage.propTypes = {
  agentdetail: PropTypes.object,
  teamProfileData: PropTypes.array,
  socialUpdates: PropTypes.func,
  fetchCheckins: PropTypes.func,
  feedback: PropTypes.func,
  hestiaData: PropTypes.object,
  teamProfile: PropTypes.func,
  recommendation: PropTypes.func,
  feedbackData: PropTypes.array,
  recommendationData: PropTypes.array,
  socialUpdateData: PropTypes.array,
  profileloading: PropTypes.bool,
  farprofileloading: PropTypes.bool,
  showShareModal: PropTypes.func,
  ask_a_question_modal: PropTypes.func,
  showReviewModal: PropTypes.func,
  hestiaInformation: PropTypes.func,
  showRecommendationModal: PropTypes.func,
  query: PropTypes.object,
  fetchCheckinsData: PropTypes.array,
  profileData: PropTypes.object,
  profile: PropTypes.func,
  clickDetectorAndScroll: PropTypes.func,
  clickDetectorData: PropTypes.object,
  isBotAndDeviceType: PropTypes.object,
  isGoogleBot: PropTypes.bool,
  socialloading: PropTypes.bool,
};
